module.exports = __webpack_public_path__ + "img/elm.3d8e2da5.png";